import { render, staticRenderFns } from "./PaperList.vue?vue&type=template&id=9bb85702&scoped=true&"
import script from "./PaperList.vue?vue&type=script&lang=js&"
export * from "./PaperList.vue?vue&type=script&lang=js&"
import style0 from "./PaperList.vue?vue&type=style&index=0&id=9bb85702&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9bb85702",
  null
  
)

component.options.__file = "PaperList.vue"
export default component.exports